export type DeliveryInfoRowType =
  | 'PENDING'
  | 'IN TRANSIT'
  | '<3 DAYS'
  | '3-5 DAYS'
  | '>5 DAYS'
  | 'EXCEPTION MAIL'
  | 'TOTAL VOLUME';
export const DeliveryInfoRowArr: DeliveryInfoRowType[] = [
  'PENDING',
  'IN TRANSIT',
  '<3 DAYS',
  '3-5 DAYS',
  '>5 DAYS',
  'EXCEPTION MAIL',
  'TOTAL VOLUME',
];

export interface DeliveryInfoRow {
  id: string;
  duration: DeliveryInfoRowType; // type: DeliveryInfoRowType;
  percentage: number;
  complete: number;
}

export const deliveryInfoData: DeliveryInfoRow[] = [
  {
    id: '456',
    duration: '<3 DAYS',
    percentage: 10,
    complete: 1,
  },
  {
    id: '567',
    duration: '3-5 DAYS',
    percentage: 30,
    complete: 3,
  },
  {
    id: '678',
    duration: '>5 DAYS',
    percentage: 10,
    complete: 1,
  },
  {
    id: '234',
    duration: 'IN TRANSIT',
    percentage: 20,
    complete: 2,
  },
  {
    id: '123',
    duration: 'PENDING',
    percentage: 20,
    complete: 2,
  },
  {
    id: '789',
    duration: 'EXCEPTION MAIL',
    percentage: 10,
    complete: 1,
  },
  {
    id: '890',
    duration: 'TOTAL VOLUME',
    percentage: 100,
    complete: 10,
  },
];
